export default __webpack_public_path__ + "static/mobile-depression-796ee569d581a182fe8aa120e5998518.webp";